<template>
  <div>
    <Head title="Formulario" />
    <div class="flex justify-between mb-8">
      <h1 class="text-3xl font-bold">Formulario</h1>
      <div>
        <Link class="btn-indigo" href="/formularios/guardar">
          <span>Guardar</span>
        </Link>
        <Link class="btn-orange ml-2" href="/formularios/enviar">
          <span>Enviar</span>
        </Link>
      </div>
    </div>
    <div class="px-8 py-4 shadow rounded-t bg-gray-50 border-t border-gray-100">
      <h2 class="text-2xl font-bold">Declaración mensual</h2>
    </div>
    <div class="bg-white shadow font-bold overflow-x-auto p-4">
      <text-input class="pb-2 pr-6 w-full lg:w-1/2" placeholder="Fecha" />
      <text-input class="pb-2 pr-6 w-full lg:w-1/2" placeholder="Oficina" />
      <text-input class="pb-2 pr-6 w-full lg:w-1/2" placeholder="Código BDT" />
      <text-input class="pb-2 pr-6 w-full lg:w-1/2" placeholder="Firmas mes" />
      <text-input class="pb-2 pr-6 w-full lg:w-1/2" placeholder="Agentes activos" />
      <text-input class="pb-2 pr-6 w-full lg:w-1/2" placeholder="Contactos" />
      <text-input class="pb-2 pr-6 w-full lg:w-1/2" placeholder="Nº oficinas Tecnocasa" />
    </div>
    <div class="px-8 py-4 shadow rounded-b bg-gray-50 border-t border-gray-100">
      <h3 class="text-xl font-bold">Oficinas Tecnocasa asignadas</h3>
    </div>
    <div class="bg-white shadow font-bold overflow-x-auto p-4">
      <table class="w-full text-center">
        <thead class="bg-gray-500 text-white">
          <tr>
            <th class="px-4 py-2">Código BDT</th>
            <th class="px-4 py-2">Razón social</th>
            <th class="px-4 py-2">Hipotecas</th>
            <th class="px-4 py-2">Estudios financieros</th>
            <th class="px-4 py-2">Encargos</th>
            <th class="px-4 py-2">Propuestas aceptadas</th>
            <th class="px-4 py-2">Citas aportadas</th>
            <th class="px-4 py-2">Total citas ventas</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="border px-4 py-2 bg-gray-200">md001</td>
            <td class="border px-4 py-2">Pradillo s.l.</td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
          </tr>
          <tr>
            <td class="border px-4 py-2 bg-gray-200">md001</td>
            <td class="border px-4 py-2">Pradillo s.l.</td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
          </tr>
          <tr>
            <td class="border px-4 py-2 bg-gray-200">md001</td>
            <td class="border px-4 py-2">Pradillo s.l.</td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
            <td class="border px-4 py-2"><text-input class="w-full" /></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput.vue'

export default {
  components: {
    Head,
    Link,
    TextInput,
  },
  layout: Layout,
}
</script>
